try {
    window.$ = window.jQuery = require('jquery');

    require('owl.carousel');

    $('.articles-carousel').owlCarousel({
        stagePadding: 0,
        loop:true,
        margin:10,
        responsiveClass:true,
        nav:true,
        responsive:{
            0:{
                items:1,
                stagePadding: 50,
            },
            600:{
                items:1,
                stagePadding: 50,

            },
            900:{
                items:3
            },
            1200:{
                items:4
            }
        }
    });
    $('.partners-carousel').owlCarousel({
        stagePadding: 0,
        loop:true,
        margin:10,
        responsiveClass:false,
        autoWidth:true,
        dots:false,
        nav:true,
        responsive:{
            0:{
                items:2,
            },
            600:{
                items:5,
            },
            900:{
                items:5
            },
            1200:{
                items:5
            }
        }
    });
    $('.model-carousel').owlCarousel({
        stagePadding: 0,
        margin:10,
        responsiveClass:false,
        autoWidth:true,
        loop:false,
        rewind: true,
        dots:false,
        nav:true,
        responsive:{
            0:{
                items:2,
            },
            600:{
                items:2,
            },
            900:{
                items:4
            },
            1200:{
                items:4
            }
        }
    });
} catch (e) {}
